import React from 'react';
import {
    Stack,
    Heading,
    Badge,
} from '@shopify/polaris';
import './OperationStepHeader.scss';

function OperationStepHeader(props) {

    return (
        <div className="operationStepHeader">
            <Stack alignment="center">
                <Badge size="medium"><Heading>&nbsp;{props.number}&nbsp;</Heading>
                </Badge><Heading>{props.text}</Heading>
            </Stack>
        </div>);

}

export default OperationStepHeader;